/* eslint-disable react/function-component-definition */
import React from 'react';

const Profile = () => {
  return (
    <div>Profile</div>
  );
};

export default Profile;
